import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

// Environement
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiUrl = environment.apiUrl;

  constructor(public httpClient: HttpClient,) { }

  // COMMS
  sendEmail(params: {}, captchaToken: string ) {
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
      body: params
    }

    return this.httpClient.post<any>(this.apiUrl + '/comms/email', params, options).pipe(
      catchError(this.handleError)
    );
  }

  // CRM
  createComplaint(params: {}, captchaToken: string ){
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
      body: params
    }

    return this.httpClient.post<any>(this.apiUrl + '/crm/request/public', params, options).pipe(
      catchError(this.handleError)
    );
  }
  
  getComplaint(id: string, captchaToken: string){
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
    }

    return this.httpClient.get<any>(this.apiUrl + '/crm/request/' + id + '/public', options).pipe(
      catchError(this.handleError)
    )
  }
  
  getReservation(id: string, captchaToken: string){
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
    }

    return this.httpClient.get<any>(this.apiUrl + '/crm/request/' + id + '/public', options).pipe(
      catchError(this.handleError)
    )
  }
  
  editReservation(id: string, params: {}, captchaToken: string){
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
    }

    return this.httpClient.put<any>(this.apiUrl + '/crm/request/' + id + '/public', params, options).pipe(
      catchError(this.handleError)
    )
  }

  createMember(params: {}, captchaToken: string ){
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
      body: params
    }

    return this.httpClient.post<any>(this.apiUrl + '/crm/member', params, options).pipe(
      catchError(this.handleError)
    );
  }

  validateMember(params: {}, captchaToken: string ){
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
      params: params
    }

    return this.httpClient.get<any>(this.apiUrl + '/crm/member/validation', options).pipe(
      catchError(this.handleError)
    );
  }
  
  createRequest(params: {}, captchaToken: string ){
    let options = {
      headers: {
        'Authentication': captchaToken,
      },
      observe: 'response' as 'body',
      body: params
    }

    return this.httpClient.post<any>(this.apiUrl + '/crm/request/public', params, options).pipe(
      catchError(this.handleError)
    );
  }


  // FILES
  createFile(file: {}, type: string) {
    let options = {
      headers: {},
      observe: 'response' as 'body',
    }

    return this.httpClient.put<any>(this.apiUrl + '/files/?type=' + type, file, options).pipe(
      catchError(this.handleError)
    )
  }


  // Feed Info
  getFeedInfo(){
    let options = {
      headers: {},
      observe: 'response' as 'body',
      body: {}
    }

    return this.httpClient.post<any>(this.apiUrl + '/busdata/gtfs/feed_info', options).pipe(
      catchError(this.handleError)
    );
  }


  // SHAPES
  getShapes(params: {}){
    let options = {
      headers: {},
      observe: 'response' as 'body',
      body: params
    }

    return this.httpClient.post<any>(this.apiUrl + '/busdata/gtfs/shapes', params, options).pipe(
      catchError(this.handleError)
    );
  }

  // TIMETABLE
  getTimetable(params: {}) {
    let options = {
      headers: {},
      observe: 'response' as 'body',
      params: params
    }

    return this.httpClient.get<any>(this.apiUrl + '/busdata/gtfs/timetable', options).pipe(
      catchError(this.handleError)
    );
  }

  // STOPS 
  getStopsByRoute(params: {}){
    let options = {
      headers: {},
      observe: 'response' as 'body',
      body: params
    }

    return this.httpClient.post<any>(this.apiUrl + '/busdata/gtfs/stops', params, options).pipe(
      catchError(this.handleError)
    );
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      // console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      // console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
      return throwError(error);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

}
